import { isNumber } from 'highcharts';

export const getSeriesName = (currentSeries, nameEvent, idEvent, isSplitBy = false) => {
  if (isSplitBy) {
    const prefix = idEvent.length ? `${idEvent}.` : '';
    return `${prefix}${nameEvent}-${currentSeries.name}`;
  }
  return idEvent === '' || isNumber(idEvent) ? nameEvent : `${idEvent}.${nameEvent}`;
};

export const getLegendName = (data, legendName) => {
  const isSplitBy = data.some((event) => event.isSplitBy);
  if (isSplitBy) {
    const filteredData = data.filter((event) => !event.id.toLowerCase().includes('others'));
    return filteredData
      .map((event) => {
        const { id, name } = event;
        return id === 'Formula' ? legendName || `${id}.${name}` : `${id}.${name}`;
      })
      .join(' ');
  }
  return '';
};

export const checkNameForFormulaLegendName = (name, parentId, isSplitBy, legendName) => {
  if (legendName && parentId === 'Formula') {
    if (isSplitBy) {
      const count = name?.split('-').at(-1);
      return count ? `${legendName}-${count}` : legendName;
    }
    return legendName;
  }
  return name;
};
